<template>
<div class="d-flex flex-fill flex-column scrollable">
  <div class="row text-center m-1">
    <div class="col-12">
      <span class="thick">Database schema (current DB: {{ this.db.toUpperCase() }})</span>
    </div>
  </div>
  <div class="row m-1 d-flex flex-fill scrollable">
    <div class="col-12 scrollable" style="max-height: 100%">
      <b-tree-view v-if="this.treeData.length !== 0" :data="treeData" :contextMenu="false" :renameNodeOnDblClick="false"></b-tree-view>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    treeData() {
      // convert to required format
      let formattedData = []
      for (let i = 0; i < this.tables.length; i++) {
        let columns = [];
        for (let j = 0; j < this.tables[i].columns.length; ++j) {
          columns.push({"name": this.tables[i].columns[j]});
        }
        formattedData.push({"name": this.tables[i].name, "children": columns});
      }
      return formattedData
    },
    ...mapState([
      'db',
      'tables'
    ])
  }
}
</script>
